import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';

type OrderByLookupType = Record<
  string,
  {
    sortDirection: 'Ascending' | 'Descending';
    sortCondition: 'CreatedDate' | 'Price';
  }
>;

export const orderByLookup: OrderByLookupType = {
  NEWEST: { sortDirection: 'Descending', sortCondition: 'CreatedDate' },
  OLDEST: { sortDirection: 'Ascending', sortCondition: 'CreatedDate' },
  HIGHEST: { sortDirection: 'Descending', sortCondition: 'Price' },
  CHEAPEST: { sortDirection: 'Ascending', sortCondition: 'Price' },
};

export const orderMock: MultiLevelMenuItem[] = [
  { label: 'جدید‌ترین', value: 'NEWEST', inputType: 'radio' },
  { label: 'قدیمی‌ترین', value: 'OLDEST', inputType: 'radio' },
  { label: 'گران‌ترین', value: 'HIGHEST', inputType: 'radio' },
  {
    label: 'ارزان‌ترین',
    value: 'CHEAPEST',
    inputType: 'radio',
  },
];

export const homeOrderMock: MultiLevelMenuItem[] = [
  { label: 'پیشنهادی', value: 'Recommended', inputType: 'radio' },
  { label: 'قدیمی‌ترین', value: 'Oldest', inputType: 'radio' },
  { label: 'جدیدترین', value: 'Newest', inputType: 'radio' },
];
